export const USER = "USER";
export const PASSWORD = "PASSWORD";
export const USER_UPDATE = "USER_UPDATE";
export const NOTIFICATION = "NOTIFICATION";
export const EMAIL_SIGNATURE = "EMAIL_SIGNATURE";

export const FETCH = "FETCH";
export const UPDATE = "UPDATE";
export const CREATE = "CREATE";
export const DELETE = "DELETE";
export const INVALIDATE = "INVALIDATE";

export const CAPABILITIES = "CAPABILITIES";
export const USERS = "USERS";
export const CONTENT_MODERATORS = "CONTENT_MODERATORS";
export const ACTIVITY_EVENTS = "ACTIVITY_EVENTS";

export const INTEGRATIONS = "INTEGRATIONS";

export const ADOPTION = "ADOPTION";
export const TRACK = "TRACK";
export const IDENTIFY = "IDENTIFY";

export const ACCOUNT = "ACCOUNT";

export const UPLOAD = "UPLOAD";
export const MEDIA = "MEDIA";
export const ACTIVATION = "ACTIVATION";
export const CUSTOM_FIELDS = 'CUSTOM_FIELDS';
export const CUSTOM_FIELD_CREATE = 'CUSTOM_FIELD_CREATE';
export const CUSTOM_FIELD_UPDATE = 'CUSTOM_FIELD_UPDATE';
export const CUSTOM_FIELD_DELETE = 'CUSTOM_FIELD_DELETE';
export const CUSTOM_FIELD_ORDER = 'CUSTOM_FIELD_ORDER';
export const DEAL_ROOM_MENTIONS_SEARCH = "DEAL_ROOM_MENTIONS_SEARCH";

export const USER_ROLES = 'USER_ROLES';
export const DATA_SOURCE = "DATA_SOURCE";
export const MIGRATE = "MIGRATE";
export const RSS = "RSS";
export const AUTHENTICATE = "AUTHENTICATE";
export const STORAGE_LIMIT = "STORAGE_LIMIT";
export const ACTION_NEEDED = "ACTION_NEEDED";
export const KEYS = "KEYS";

export const STREAM_ACCESS = "STREAM_ACCESS";
export const STREAM_ANALYTICS = "STREAM_ANALYTICS";
export const MANAGE_ACCESS = "MANAGE_ACCESS";

export const VIEWER_SETTINGS = "VIEWER_SETTINGS";

//hubspot
export const HUBSPOT_PIPELINES = "HUBSPOT_PIPELINES";

//tours
export const PRODUCT_TOURS = "PRODUCT_TOURS";

// deal insights
export const DEAL_INSIGHTS = "DEAL_INSIGHTS";
export const DEAL_CHAT = "DEAL_CHAT";
export const DEAL_AGENT_SESSIONS = "DEAL_AGENT_SESSIONS";
export const DEAL_AGENT_SUGGESTIONS = "DEAL_AGENT_SUGGESTIONS";
export const DEAL_DETAILS = "DEAL_DETAILS";
export const DEAL_INSIGHTS_NUDGES = "DEAL_INSIGHTS_NUDGES";
export const DEAL_INSIGHTS_SUMMARY = "DEAL_INSIGHTS_SUMMARY";
export const DEAL_INSIGHTS_FILTER_OPTIONS = "DEAL_INSIGHTS_FILTER_OPTIONS";
export const DEAL_INSIGHTS_LIST = "DEAL_INSIGHTS_LIST";
export const DEAL_INSIGHTS_ACTIVITIES = "DEAL_INSIGHTS_ACTIVITIES";
export const DEAL_INSIGHTS_DETAIL = "DEAL_INSIGHTS_DETAIL";
export const DEAL_INSIGHTS_TIMELINE = "DEAL_INSIGHTS_TIMELINE";
export const DEAL_INSIGHTS_SYNC = "DEAL_INSIGHTS_SYNC";

// Chat users (engage)
export const CHAT_USERS = "CHAT_USERS";
export const CHAT_USER = "CHAT_USER";
export const CHAT_USER_NUDGES = "CHAT_USER_NUDGES";
export const CHAT_USER_LOCATIONS = "CHAT_USER_LOCATIONS";

// SMS / Phone verification
export const SMS_VERIFICATION = "SMS_VERIFICATION";
export const PHONE_VERIFICATION = "PHONE_VERIFICATION";
export const SEND = "SEND";
export const RESEND = "RESEND";
export const CONFIRM = "CONFIRM";
export const STATUS = "STATUS";

// Small talk
export const SMALL_TALK = "SMALL_TALK";
export const SMALL_TALK_SESSION = "SMALL_TALK_SESSION";
export const SMALL_TALK_MESSAGES = "SMALL_TALK_MESSAGES";
export const SMALL_TALK_PRESENCE = "SMALL_TALK_PRESENCE";
